var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatDetectorFireAlarmSounder01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.15;stroke-miterlimit:10;}\n\t.st1{font-family:'MyriadPro-Regular';}\n\t.st2{font-size:6.126px;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8,
    cy: 8,
    r: 4.5
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 5.9512 10.0393)",
    className: "st1 st2"
  }, "H"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatDetectorFireAlarmSounder01);
export default __webpack_public_path__ + "static/media/HeatDetectorFireAlarmSounder-01.24ff21e5f714980c776c73feab8c504a.svg";
export { ForwardRef as ReactComponent };